import { toast } from 'react-toastify';
import { toastResponse } from '../../../helper components/Toast/Toast';

import { useEffect, useState, useCallback } from 'react';
import lang from '../../../assets/i18n/en.json';
import Form from 'react-bootstrap/Form';
import { comparePasswords } from '../../../utils/Utils';
import allImages from '../../../assets/images/allImages';
import Button from 'react-bootstrap/Button';
import { GetInvitedEnterpriseClientById } from '../../../Queries/Queries';
import { SetEnterpriseClientPasswordByReset } from '../../../Mutations/Mutations';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import { setLoaderFalse, setLoaderTrue } from '../../../Redux/loaderSlice';
import { useDispatch } from 'react-redux';

export const Reset = () => {
  const PAGE = lang.PAGE;
  const client = useApolloClient();
  const dispatch = useDispatch();

  const urlRequestId = new URLSearchParams(window.location.search).get(
    'requestId',
  );

  const [passwordToggle, setPasswordToggle] = useState(true);
  const [confirmPasswordToggle, setConfirmPasswordToggle] = useState(true);
  const [resetPassword, setResetPassword] = useState({
    password: '',
    confirmPassword: '',
  });

  const [errors, setError] = useState({
    password: false,
    passwordError: '',
    confirmPasswordError: '',
    confirmPassword: false,
  });

  const [userData, setUserData] = useState();

  const { refetch } = useQuery(GetInvitedEnterpriseClientById);

  //Assign mutaions to variable
  const [fnResetPasswordEnterpriseClient, { loading }] = useMutation(
    SetEnterpriseClientPasswordByReset,
    {
      onCompleted: (data) => {
        // navigate("/user/login")
        toast.success(toastResponse('success', 'Reset password successfully.'));

        // setShowConfirmationPopup(true);
        // props.onHide();
        // isLoginResponse(data);
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    },
  );

  const fetchInvitedClientData = useCallback(async () => {
    refetch();

    //Animated Loader true
    dispatch(setLoaderTrue());
    try {
      const { data } = await client.query({
        query: GetInvitedEnterpriseClientById,
        variables: { getInvitedEnterpriseClientByIdId: urlRequestId },
      });

      setUserData(data?.getInvitedEnterpriseClientById);

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  },[client,dispatch, refetch, urlRequestId]);

  useEffect(() => {
    if (urlRequestId) {
      fetchInvitedClientData();
    }
  }, [urlRequestId, fetchInvitedClientData]);

  const onSubmit = async () => {
    try {
      // let data = {
      //     "enterpriseClientId": userData.id,
      //     "newPassword": resetPassword.password
      // }

      // if (data) {
      fnResetPasswordEnterpriseClient({
        variables: {
          enterpriseClientId: userData.id,
          newPassword: resetPassword.password,
        },
      });
      // }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form className="form">
      <div className="pb-5 pb-lg-10">
        <p
          className="login-registration-form pageTitle h1 fw-bolder text-dark"
          id="forgot_password_title"
        >
          {PAGE.AUTH.RESET_PASSWORD.TITLE}
        </p>
      </div>
      <div className="mb-6">
        <Form.Label>New Password</Form.Label>
        <div className="position-relative">
          <Form.Control
            type={passwordToggle ? 'password' : 'text'}
            className="form-control form-control-lg form-control-solid fs-6 "
            autoComplete="new-password"
            isInvalid={errors.password}
            onChange={(e) => {
              setResetPassword((resetPassword) => ({
                ...resetPassword,
                password: e.target.value,
              }));
              comparePasswords(
                'password',
                e.target.value,
                resetPassword.confirmPassword,
                setError,
              );
            }}
          />
          <div className="showPasswordBlock">
            <img
              src={allImages.showPwd}
              className="container-fluid"
              style={{ display: !passwordToggle ? 'block' : 'none' }}
              onClick={(e) => {
                setPasswordToggle((passwordToggle) => !passwordToggle);
              }}
              alt="show_password_icon"
            />
            <img
              src={allImages.hidePwd}
              className="container-fluid"
              style={{ display: passwordToggle ? 'block' : 'none' }}
              onClick={(e) =>
                setPasswordToggle((passwordToggle) => !passwordToggle)
              }
              alt="hide_password_icon"
            />
          </div>
        </div>
        <Form.Control.Feedback
          type="required"
          autoComplete="new-password"
          style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }}
        >
          {errors.passwordError}
        </Form.Control.Feedback>
      </div>

      <div className="mb-6">
        {/* <Form.Label className='loginRegisterBlock formControlLabel text-dark w-100'>
                                <span>Confirm Password</span>
                            </Form.Label> */}
        <div className="position-relative">
          <Form.Label>Confirm Password</Form.Label>

          <Form.Control
            type={confirmPasswordToggle ? 'password' : 'text'}
            className="form-control form-control-lg form-control-solid fs-6 "
            isInvalid={errors.confirmPassword}
            onChange={(e) => {
              setResetPassword((resetPassword) => ({
                ...resetPassword,
                confirmPassword: e.target.value,
              }));
              comparePasswords(
                'confirmpassword',
                e.target.value,
                resetPassword.password,
                setError,
              );
            }}
          />
          <div className="showPasswordBlock">
            <img
              src={allImages.showPwd}
              className="container-fluid"
              style={{ display: !confirmPasswordToggle ? 'block' : 'none' }}
              onClick={(e) => {
                setConfirmPasswordToggle(
                  (confirmPasswordToggle) => !confirmPasswordToggle,
                );
              }}
              alt="show_password_icon"
            />
            <img
              src={allImages.hidePwd}
              className="container-fluid"
              style={{ display: confirmPasswordToggle ? 'block' : 'none' }}
              onClick={(e) =>
                setConfirmPasswordToggle(
                  (confirmPasswordToggle) => !confirmPasswordToggle,
                )
              }
              alt="hide_password_icon"
            />
          </div>
        </div>
        <Form.Control.Feedback
          type="required"
          style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }}
        >
          {errors.confirmPasswordError}
        </Form.Control.Feedback>
      </div>

      <Button
        className="theme btn btn-primary me-4"
        disabled={
          !(
            resetPassword.password &&
            resetPassword.confirmPassword &&
            !errors.password &&
            !errors.confirmPassword
          )
        }
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        Save
        {loading && (
          <i className="spinner-grow spinner-grow-sm ms-3" role="status" />
        )}
      </Button>
    </form>
  );
};
